export default {
  'pages.rounds.reports': 'Reports',
  'pages.rounds.operators': 'Operators',
  'pages.rounds.games': 'Games',
  'pages.rounds.userId': 'Operator User ID',
  'pages.rounds.transactionGroupId': 'Transaction Group ID',
  'pages.rounds.rgsUserId': 'RGS User ID',
  'pages.rounds.partnerName': 'Partner Name',
  'pages.rounds.endDate': 'End Date',
  'pages.rounds.startDate': 'Start Date',
  'pages.rounds.search': 'Search',
  'pages.rounds.errorText': 'Error MSG',
  'pages.rounds.errorCode': 'Error Code',
  'pages.rounds.currency': 'Currency',
  'pages.rounds.status': 'Status',
  'pages.rounds.betAmount': 'Bet Amount',
  'pages.rounds.winAmount': 'Win Amount',
  'pages.rounds.multiplier': 'Multiplier',
  'pages.rounds.crashPoint': 'Crash Point',
  'pages.rounds.betId': 'Bet ID',
  'pages.rounds.gameName': 'Game Name',
  'pages.rounds.username': 'User Name',
  'pages.rounds.createdAt': 'Created At',
  'pages.rounds.tripId': 'Trip ID',
  'pages.rounds.partnerNameRequired': 'Partner Name (Required)',
  'pages.rounds.operatorUserIdRequired': 'Operator User ID (Required)',
  'pages.rounds.betIdRequired': 'Bet ID (Required)',
  'pages.rounds.rgsUserIdRequired': 'RGS User Id (Required)',
  'pages.rounds.transactionGroupIdRequired': 'Transaction Group ID (Required)',
  'pages.players.reports': 'Reports',
  'pages.players.betNumber': 'Bet Number',
  'pages.players.name': 'Player',
  'pages.players.endDate': 'End Date',
  'pages.players.startDate': 'Start Date',
  'pages.players.search': 'Search',
  'pages.players.games': 'Games',
  'pages.players.id': 'Player ID',
  'pages.players.operators': 'Operators',
  'pages.players.partners': 'Partners',
  'pages.players.partner': 'Partner',
  'pages.players.operator': 'Operator',
  'pages.players.game': 'Game',
  'pages.players.bet': 'Bet',
  'pages.players.win': 'Win',
  'pages.players.ggr': 'GGR',
  'pages.players.users': 'Users',
  'pages.players.spins': 'Spins',
  'pages.stats.reports': 'Reports',
  'pages.stats.betNumber': 'Bet Number',
  'pages.stats.endDate': 'End Date',
  'pages.stats.startDate': 'Start Date',
  'pages.stats.search': 'Search',
  'pages.stats.games': 'Games',
  'pages.stats.operators': 'Operators',
  'pages.stats.partners': 'Partners',
  'pages.stats.partner': 'Partner',
  'pages.stats.operator': 'Operator',
  'pages.stats.game': 'Game',
  'pages.stats.bet': 'Bet',
  'pages.stats.win': 'Win',
  'pages.stats.ggr': 'GGR',
  'pages.stats.users': 'Users',
  'pages.stats.spins': 'Spins',
  'pages.dashboard.betWins': 'Bet Wins',
  'pages.stats.today': 'Today',
  'pages.stats.yesterday': 'Yesterday',
  'pages.dashboard.players': 'Players',
  'pages.dashboard.ggr': 'GGR',
  'pages.dashboard.spins': 'Spins',
  'pages.dashboard.topPlayers': 'Top Players',
  'pages.dashboard.player': 'Player',
  'pages.dashboard.win': 'Win',
  'pages.dashboard.bet': 'Bet',
  'pages.dashboard.game': 'Game',
  'pages.dashboard.operator': 'Operator',
  'pages.dashboard.partner': 'Partner',
  'pages.dashboard.numOfUniqueUsers': 'Number Of Unique Users',
  'pages.dashboard.numberSpins': 'Number Spins',
  'pages.dashboard.search': 'Search',
  'pages.dashboard.games': 'Games',
  'pages.dashboard.operators': 'Operators',
  'pages.dashboard.partners': 'Partners',
  'pages.dashboard.live': 'Live',
  'pages.dashboard.detailedLivePlayers': 'Detailed Live Players',
  'pages.dashboard.groupBy': 'Group By',
  'pages.dashboard.liveCount': 'Live Count',
  'pages.dashboard.livePlayers': 'Live Players',
  'pages.dashboard.partnerOperator': 'Partner+Operator',
  'pages.dashboard.fetchDataError': 'Failed to fetch data',
  'pages.layouts.userLayout.title': 'RGS',
  'pages.login.accountLogin.tab': 'Account Login',
  'pages.login.accountLogin.errorMessage': 'Incorrect username/password(admin/ant.design)',
  'pages.login.failure': 'Login failed, please try again!',
  'pages.login.success': 'Login successful!',
  'pages.login.username.placeholder': 'Username',
  'pages.login.username.required': 'Please input your username!',
  'pages.login.password.placeholder': 'Password',
  'pages.login.password.required': 'Please input your password!',
  'pages.login.phoneLogin.tab': 'Phone Login',
  'pages.login.phoneLogin.errorMessage': 'Verification Code Error',
  'pages.login.phoneNumber.placeholder': 'Phone Number',
  'pages.login.phoneNumber.required': 'Please input your phone number!',
  'pages.login.phoneNumber.invalid': 'Phone number is invalid!',
  'pages.login.captcha.placeholder': 'Verification Code',
  'pages.login.captcha.required': 'Please input verification code!',
  'pages.login.phoneLogin.getVerificationCode': 'Get Code',
  'pages.getCaptchaSecondText': 'sec(s)',
  'pages.login.rememberMe': 'Remember me',
  'pages.login.forgotPassword': 'Forgot Password ?',
  'pages.login.submit': 'Login',
  'pages.login.loginWith': 'Login with :',
  'pages.login.registerAccount': 'Register Account',
  'pages.welcome.link': 'Welcome',
  'pages.welcome.alertMessage': 'Faster and stronger heavy-duty components have been released.',
  'pages.404.subTitle': 'Sorry, the page you visited does not exist.',
  'pages.404.buttonText': 'Back Home',
  'pages.admin.subpages.title': 'This page can only be viewed by Admin',
  'pages.admin.subpages.alertMessage':
    'Umi ui is now released, welcome to use npm run ui to start the experience.',
  'pages.searchTable.createForm.newRule': 'New Rule',
  'pages.searchTable.updateForm.ruleConfig': 'Rule configuration',
  'pages.searchTable.updateForm.basicConfig': 'Basic Information',
  'pages.searchTable.updateForm.ruleName.nameLabel': 'Rule Name',
  'pages.searchTable.updateForm.ruleName.nameRules': 'Please enter the rule name!',
  'pages.searchTable.updateForm.ruleDesc.descLabel': 'Rule Description',
  'pages.searchTable.updateForm.ruleDesc.descPlaceholder': 'Please enter at least five characters',
  'pages.searchTable.updateForm.ruleDesc.descRules':
    'Please enter a rule description of at least five characters!',
  'pages.searchTable.updateForm.ruleProps.title': 'Configure Properties',
  'pages.searchTable.updateForm.object': 'Monitoring Object',
  'pages.searchTable.updateForm.ruleProps.templateLabel': 'Rule Template',
  'pages.searchTable.updateForm.ruleProps.typeLabel': 'Rule Type',
  'pages.searchTable.updateForm.schedulingPeriod.title': 'Set Scheduling Period',
  'pages.searchTable.updateForm.schedulingPeriod.timeLabel': 'Starting Time',
  'pages.searchTable.updateForm.schedulingPeriod.timeRules': 'Please choose a start time!',
  'pages.searchTable.titleDesc': 'Description',
  'pages.searchTable.ruleName': 'Rule name is required',
  'pages.searchTable.titleCallNo': 'Number of Service Calls',
  'pages.searchTable.titleStatus': 'Status',
  'pages.searchTable.nameStatus.default': 'default',
  'pages.searchTable.nameStatus.running': 'running',
  'pages.searchTable.nameStatus.online': 'online',
  'pages.searchTable.nameStatus.abnormal': 'abnormal',
  'pages.searchTable.titleUpdatedAt': 'Last Scheduled at',
  'pages.searchTable.exception': 'Please enter the reason for the exception!',
  'pages.searchTable.titleOption': 'Option',
  'pages.searchTable.config': 'Configuration',
  'pages.searchTable.subscribeAlert': 'Subscribe to alerts',
  'pages.searchTable.title': 'Enquiry Form',
  'pages.searchTable.new': 'New',
  'pages.searchTable.chosen': 'chosen',
  'pages.searchTable.item': 'item',
  'pages.searchTable.totalServiceCalls': 'Total Number of Service Calls',
  'pages.searchTable.tenThousand': '0000',
  'pages.searchTable.batchDeletion': 'batch deletion',
  'pages.searchTable.batchApproval': 'batch approval',
  'pages.promoCampaign.promo': 'Promo Tool',
  'pages.promoCampaign.name': 'Name',
  'pages.promoCampaign.partner': 'Partner',
  'pages.promoCampaign.game': 'Game',
  'pages.promoCampaign.status': 'Status',
  'pages.promoCampaign.createdAt': 'Created At',
  'pages.promoCampaign.filter.partnerName': 'Filter by partner name',
  'pages.promoCampaign.filter.excludeDeleted': 'Exclude deleted',
  'pages.promoCampaign.generalSettings': 'General Settings',
  'pages.promoCampaign.campaignName': 'Campaign Name',
  'pages.promoCampaign.currencies': 'Currencies',
  'pages.promoCampaign.currency': 'Currency',
  'pages.promoCampaign.partners': 'Partners',
  'pages.promoCampaign.operators': 'Operators',
  'pages.promoCampaign.games': 'Games',
  'pages.promoCampaign.startDate': 'Start Date (UTC)',
  'pages.promoCampaign.endDate': 'End Date (UTC)',
  'pages.promoCampaign.distributionWindowStartHour': 'Distribution Window - Start Hour (UTC)',
  'pages.promoCampaign.startHour': 'Start Hour (UTC)',
  'pages.promoCampaign.distributionWindowEndHour': 'Distribution Window - End Hour (UTC)',
  'pages.promoCampaign.endHour': 'End Hour (UTC)',
  'pages.promoCampaign.eventsPerDay': 'Events Per Day',
  'pages.promoCampaign.eventAndGiftParameters': 'Event & Gift Parameters',
  'pages.promoCampaign.showGiftAmountsToPlayers': 'Show gift amounts to players',
  'pages.promoCampaign.giftType': 'Gift Type',
  'pages.promoCampaign.numberOfGifts': 'Number of Gifts',
  'pages.promoCampaign.giftValue': 'Gift Value',
  'pages.promoCampaign.giftValues': 'Gift Values',
  'pages.promoCampaign.minCashoutMultiplier': 'Min cashout multiplier',
  'pages.promoCampaign.editValues': 'Edit',
  'pages.promoCampaign.editGiftValues': 'Edit gift values',
  'pages.promoCampaign.selectCurrenciesFirst': 'Select currencies in General Settings first',
  'pages.promoCampaign.actions': 'Actions',
  'pages.promoCampaign.view': 'View',
  'pages.promoCampaign.delete': 'Delete',
  'pages.promoCampaign.deleteSuccess': 'Campaign deleted',
  'pages.promoCampaign.deleteError': 'Failed to delete campaign',
  'pages.promoCampaign.deleteConfirmTitle': 'Delete campaign?',
  'pages.promoCampaign.deleteConfirmDescription': 'This action cannot be undone.',
  'pages.promoCampaign.deleteConfirmOk': 'Delete',
  'pages.promoCampaign.deleteConfirmCancel': 'Cancel',
  'pages.promoCampaign.dateRange': 'Campaign Period',
  'pages.promoCampaign.dateRangeRequired': 'Please select start and end date',
  'pages.promoCampaign.audienceAndBudgetControl': 'Audience',
  'pages.promoCampaign.eligibilityFilters': 'Eligibility Conditions',
  'pages.promoCampaign.requiredTotalWager': 'Required Total Wager',
  'pages.promoCampaign.requiredTotalWager.description':
    'The total wager required for the player to be eligible for the promo.',
  'pages.promoCampaign.lookbackMinutes': 'Lookback Minutes',
  'pages.promoCampaign.lookbackWindow.description':
    'How many minutes to look back for the total wager calculation.',
  'pages.promoCampaign.minBetAmountForBonusRound': 'Minimum Bet Amount for Bonus Round',
  'pages.promoCampaign.minTotalWagerBeforeEvent': 'Min Total Wager Before the Event',
  'pages.promoCampaign.lookbackWindow': 'Lookback Window (minutes)',
  'pages.promoCampaign.lookbackUnit.minutes': 'Minutes',
  'pages.promoCampaign.lookbackUnit.hours': 'Hours',
  'pages.promoCampaign.campaignDays': 'Campaign Days',
  'pages.promoCampaign.promoDurationSec': 'Promo Duration',
  'pages.promoCampaign.promoDurationSec.description':
    'The duration of the promo, after which it will disappear.',
  'pages.promoCampaign.durationUnit.seconds': 'Seconds',
  'pages.promoCampaign.durationUnit.minutes': 'Minutes',
  'pages.promoCampaign.durationUnit.hours': 'Hours',
  'pages.promoCampaign.durationUnit.days': 'Days',
  'pages.promoCampaign.optional': 'Optional',
  'pages.promoCampaign.claimLimitations': 'Claim Limitations',
  'pages.promoCampaign.maxClaimsPerEvent': 'Max Claims per Player per Event',
  'pages.promoCampaign.maxClaimsPerDay': 'Max Claims per Player per Day',
  'pages.promoCampaign.claimTimeLimit': 'Claim Time Limit after Drop (minutes)',
  'pages.promoCampaign.minimumCashoutMultiplierForFreeSpins':
    'Minimum Cashout Multiplier for Free Spins',
  'pages.promoCampaign.review': 'Review',
  'pages.promoCampaign.createCampaign': 'Create Campaign',
  'pages.promoCampaign.giftsPerEvent': 'Gifts per Event',
  'pages.promoCampaign.projectedExposure': 'Projected Exposure',
  'pages.promo.promoDurationSec': 'Promo Duration (seconds)',
  'pages.promo.generalSettings': 'General Settings',
  'pages.promo.campaignName': 'Campaign Name',
  'pages.promo.currencies': 'Currencies',
  'pages.promo.partners': 'Partners',
  'pages.promo.operators': 'Operators',
  'pages.promo.games': 'Games',
  'pages.promo.startDate': 'Start Date (UTC)',
  'pages.promo.endDate': 'End Date (UTC)',
  'pages.promo.distributionWindowStartHour': 'Distribution Window - Start Hour (UTC)',
  'pages.promo.startHour': 'Start Hour (UTC)',
  'pages.promo.distributionWindowEndHour': 'Distribution Window - End Hour (UTC)',
  'pages.promo.endHour': 'End Hour (UTC)',
  'pages.promo.eventsPerDay': 'Events Per Day',
  'pages.promo.eventAndGiftParameters': 'Event & Gift Parameters',
  'pages.promo.giftType': 'Gift Type',
  'pages.promo.numberOfGifts': 'Number of Gifts',
  'pages.promo.giftValue': 'Gift Value',
  'pages.promo.actions': 'Actions',
  'pages.promo.audienceAndBudgetControl': 'Audience & Budget Control',
  'pages.promo.eligibilityFilters': 'Eligibility Filters',
  'pages.promo.minTotalWagerBeforeEvent': 'Min Total Wager Before the Event',
  'pages.promo.lookbackWindow': 'Lookback Window',
  'pages.promo.claimLimitations': 'Claim Limitations',
  'pages.promo.maxClaimsPerEvent': 'Max Claims per Player per Event',
  'pages.promo.review': 'Review',
  'pages.promo.createCampaign': 'Create Campaign',
  'pages.promo.giftsPerEvent': 'Gifts per Event',
  'pages.promo.projectedExposure': 'Projected Exposure',
  'pages.report.export': 'Export',
  'pages.report.preview': 'Preview (first 30 rows)',
  'pages.report.preview.day': 'Day (UTC)',
  'pages.report.preview.gameName': 'Game Name',
  'pages.report.preview.currencyCode': 'Currency',
  'pages.report.preview.partnerName': 'Partner Name',
  'pages.report.preview.operatorName': 'Operator Name',
  'pages.report.preview.bets': 'Bets',
  'pages.report.preview.wins': 'Wins',
  'pages.report.preview.ggr': 'GGR',
  'pages.report.preview.betsEUR': 'Bets (EUR)',
  'pages.report.preview.winsEUR': 'Wins (EUR)',
  'pages.report.preview.ggrEUR': 'GGR (EUR)',
  'pages.report.exportError': 'Export Error: ',
  'pages.report.previewError': 'Preview Error: ',
  'pages.operatorSetup.partnerPlaceholder': 'Select existing partner or type new partner name',
  'pages.operatorSetup.operatorPlaceholder': 'Type new operator name',
  'pages.operatorSetup.operatorAPIEndpoint': 'Operator API Endpoint',
  'pages.operatorSetup.operatorConfig': 'Configuration',
  'pages.operatorSetup.operatorKeyConfig': 'Operator Key Setup',
  'pages.operatorSetup.operatorKeyConfig.leaveEmpty': 'Leave Empty',
  'pages.operatorSetup.operatorKeyConfig.reuse': 'Reuse existing operator key',
  'pages.operatorSetup.operatorKeyConfig.create': 'Create new key',
  'pages.operatorSetup.operatorKeyConfig.operatorKeyAction': 'Action',
  'pages.operatorSetup.operatorKeyConfig.keySourceOperator': 'Key Source Operator',
  'pages.operatorSetup.operatorKeyConfig.apiKey': 'API Key',
  'pages.operatorSetup.operatorKeyConfig.secretKey': 'Secret Key',
  'pages.operatorSetup.instructions.title': 'Operator Instructions',
  'pages.operatorSetup.createButton': 'Create',
  'pages.operatorSetup.createSuccess': 'Operator created successfully',
  'pages.operatorSetup.createError': 'Create Operator Error: ',
  'pages.operatorSetup.apiEndpointPlaceholder':
    'Select existing API endpoint or type new API endpoint',
  'pages.settings.betting.addSettingsButton': 'Add Settings',
  'pages.settings.betting.lookupSettingsButton': 'Lookup Settings',
  'pages.settings.betting.upsertButton': 'Upsert Setting',
  'pages.settings.betting.upsertTooltip': 'Upsert adds a new setting or updates the existing value',
  'pages.settings.betting.fetchError': 'Failed to fetch betting settings',
  'pages.settings.betting.convertSuccess': 'Betting settings converted and upserted successfully',
  'pages.settings.betting.convertError': 'Failed to convert and upsert betting settings',
  'pages.settings.betting.upsertSuccess': 'Betting setting upserted successfully',
  'pages.settings.betting.upsertError': 'Failed to upsert betting setting',
  'pages.settings.betting.deleteSuccess': 'Betting setting deleted successfully',
  'pages.settings.betting.deleteError': 'Failed to delete setting',
  'pages.settings.betting.partnerOptional': 'Partner (Optional)',
  'pages.settings.betting.operatorOptional': 'Operator (Optional)',
  'pages.settings.betting.gameOptional': 'Game (Optional)',
  'pages.settings.betting.partner': 'Partner',
  'pages.settings.betting.operator': 'Operator',
  'pages.settings.betting.game': 'Game',
  'pages.settings.betting.sourceCurrency': 'Source Currency',
  'pages.settings.betting.key': 'Key',
  'pages.settings.betting.value': 'Value',
  'pages.settings.betting.actions': 'Actions',
  'pages.settings.betting.delete': 'Delete',
  'pages.settings.betting.currency': 'Currency',
  'pages.settings.betting.currencies': 'Currencies',
  'pages.settings.betting.currencyPlaceholder': 'Select a currency',
  'pages.settings.betting.filterButton': 'Filter',
  'pages.settings.betting.deleteConfirmTitle': 'Do you want to delete this setting?',
  'pages.settings.betting.confirmDeleteButton': 'Delete',
  'pages.settings.betting.cancelButton': 'Cancel',
  'pages.settings.betting.leaveEmptyForGlobal': 'Leave empty for global setting',
  'pages.settings.betting.bettingSettingsContext': 'Betting Setting Context',
  'pages.settings.betting.keyPlaceholder': 'Select setting key',
  'pages.settings.betting.valuePlaceholder': 'Input setting value',
  'pages.settings.betting.settingKeyValueTitle': 'Setting Key/Value',

  'pages.assistant.type.betTransactionId': 'Round / bet transaction ID',
  'pages.assistant.type.id': 'Transaction ID',
  'pages.assistant.type.operatorTransactionId': 'Operator transaction ID',
  'pages.assistant.identifierPlaceholder': 'Identifier',
  'pages.assistant.lookUp': 'Look up',
  'pages.assistant.startAssistant': 'Ask the assistant',
  'pages.assistant.startAssistantHint': 'Sends the evidence below to the model for a diagnosis.',
  'pages.assistant.stop': 'Stop',
  'pages.assistant.newDiagnosis': 'New diagnosis',
  'pages.assistant.rangeRequired':
    'A date range is required when searching by operator transaction ID',
  'pages.assistant.rangeTooWide': 'The date range must be {days} days or less',
  'pages.assistant.rangeHint':
    'Operator transaction IDs are not indexed, so a date range is required to keep the search bounded.',
  'pages.assistant.ambiguous': 'This identifier matches more than one round — pick one',
  'pages.assistant.select': 'Open this round',
  'pages.assistant.you': 'You',
  'pages.assistant.assistant': 'Assistant',
  'pages.assistant.followUpPlaceholder': 'Ask a follow-up question',
  'pages.assistant.send': 'Send',
  'pages.assistant.evidence.transactions': 'Transactions ({count})',
  'pages.assistant.evidence.logs': 'Platform logs ({count})',
  'pages.assistant.evidence.logsSearching': 'Platform logs (searching…)',
  'pages.assistant.evidence.type': 'Type',
  'pages.assistant.evidence.status': 'Status',
  'pages.assistant.evidence.transactionId': 'Transaction ID',
  'pages.assistant.evidence.created': 'Created',
  'pages.assistant.evidence.processed': 'Processed',
  'pages.assistant.evidence.error': 'Error',
  'pages.assistant.evidence.archived': 'archived',
  'pages.assistant.evidence.round': 'Round (bet transaction ID)',
  'pages.assistant.evidence.operator': 'Operator',
  'pages.assistant.evidence.game': 'Game',
  'pages.assistant.evidence.timezoneNote': 'Times are shown in {timezone} ({offset})',
  'pages.assistant.evidence.expandRow': 'Expand row',
  'pages.assistant.evidence.collapseRow': 'Collapse row',
  'pages.assistant.evidence.requestPayload': 'Request payload',
  'pages.assistant.evidence.responsePayload': 'Response payload',
  'pages.assistant.evidence.windows': 'Searched windows',
  'pages.assistant.evidence.matched': 'Lines matched',
  'pages.assistant.evidence.truncated': 'truncated to fit the size limit',
  'pages.assistant.evidence.query': 'Query',
  'pages.assistant.evidence.logsUnavailable': 'Log evidence is unavailable',
  'pages.assistant.evidence.logsPartial': 'Log evidence is incomplete — some searches failed',
  'pages.assistant.evidence.logsEmpty': 'No matching log lines were found',
  'pages.assistant.evidence.logFilter': 'Filter lines',
  'pages.assistant.evidence.logShowing': 'Showing {shown} of {total}',
  'pages.assistant.evidence.logFilterEmpty': 'No lines match the filter',
  'pages.assistant.evidence.logsCaveat':
    'Missing logs are not evidence that nothing happened — logs are retained for a limited period, so older rounds often have none.',
  'pages.assistant.evidence.warnings': 'Some evidence could not be collected',
  'pages.assistant.evidence.eurAmounts': 'EUR (bet / win)',
  'pages.assistant.evidence.operatorCalls': 'Operator calls ({count})',
  'pages.assistant.evidence.operatorCallsEmpty':
    'No such lines were found. These are DEBUG lines and carry the body only while operator body logging is on.',
  'pages.assistant.evidence.crashPoint': 'Crash point',
  'pages.assistant.evidence.tripIdValue': 'trip {tripId}',
  'pages.assistant.evidence.eurBet': 'EUR (bet)',
  'pages.assistant.evidence.eurWin': 'EUR (win)',
  'pages.assistant.evidence.testUser': 'test user',
  'pages.assistant.evidence.bettingSettings': 'Betting limits',
  'pages.assistant.evidence.bettingSettingsValue':
    'min {minBet} · max {maxBet} · max win {maxWin}{disabled}',
  'pages.assistant.evidence.currencyDisabled': 'currency disabled',
  'pages.assistant.evidence.gameEvents': 'Game events ({count})',
  'pages.assistant.evidence.tripId': 'Trip ID',
  'pages.assistant.evidence.eventType': 'Event type',
  'pages.assistant.evidence.payload': 'Payload',
  'pages.assistant.evidence.retryQueue': 'Retry queue ({count})',
  'pages.assistant.evidence.retryCount': 'Retry count',
  'pages.assistant.evidence.updated': 'Updated',
};
